@let total = totalChatNotifications();
@if (messageNotificationButtonService.isCleaningCache()) {
  <div id="spinner-container">
    <mat-spinner diameter="20" />
  </div>
} @else {
  <button type="button" mat-icon-button [matMenuTriggerFor]="messageNotificationMenu">
    <mat-icon aria-hidden="false" [matBadgeHidden]="total < 1" [matBadge]="total.toString()" svgIcon="mail" />
  </button>
  <mat-menu #messageNotificationMenu="matMenu">
    @if (total < 1) {
      <a disabled mat-menu-item>You have no new messages</a>
    }
    @for (notification of notifications; track notification) {
      @if (notification.messages.unread > 0) {
        <a routerLink="/therapist/chat/{{ notification.chatSessionId }}" mat-menu-item>
          <div class="notification-row">
            @if (!notification.patient.email) {
              <mat-spinner diameter="25" />
            } @else {
              <app-avatar
                [matBadge]="notification.messages.unread.toString()"
                matBadgePosition="before"
                diameter="25px" />
            }
            <div id="notification-text" [class.message-notification-not-loaded]="!notification.patient.email">
              {{ notification.patient.name || notification.patient.email || 'Patient ' + notification.chatSessionId }}
            </div>
          </div>
        </a>
      }
    }
  </mat-menu>
}
